import { AxiosError } from 'axios'
import {
  type QueryFunctionContext,
  useQuery,
  type UseQueryOptions
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { monitorsQueryKeys } from 'queries/monitors/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

import type {
  DatadogMonitorRequestParams,
  IndividualDatadogMonitor
} from 'types/api/datadog/monitors'

function fetchDatadogMonitor({
  queryKey
}: QueryFunctionContext<ReturnType<typeof monitorsQueryKeys.datadog>>) {
  if (!queryKey[0]) {
    throw new AxiosError(
      'Missing critical parameters to fetch the requested Datadog monitor'
    )
  }

  return fetchQueryData(getEndpointWithParams(...queryKey))
}

export function useGetDatadogMonitor(
  monitorId: string,
  requestParams: DatadogMonitorRequestParams,
  options?: Omit<
    UseQueryOptions<IndividualDatadogMonitor, AxiosError>,
    'queryKey' | 'queryFn'
  >
) {
  const { currentTeamId: teamId } = useAuth()
  const queryKey = monitorsQueryKeys.datadog({
    monitorId,
    teamId,
    ...requestParams
  })

  return useQuery({
    ...options,
    queryKey,
    queryFn: fetchDatadogMonitor
  })
}
